import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlDe extends MatPaginatorIntl {
    override itemsPerPageLabel = 'Elemente pro Seite';
    override nextPageLabel = 'Nächste Seite';
    override previousPageLabel = 'Vorherige Seite';
}
